import { render, staticRenderFns } from "./KnowledgeBaseLayout.vue?vue&type=template&id=6579134e"
import script from "./KnowledgeBaseLayout.vue?vue&type=script&lang=js"
export * from "./KnowledgeBaseLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports